import React, { useCallback } from "react";
import { Snippet } from "react-instantsearch";
import { getUserToken } from "./AlgoliaAnalytics";
import profile from "@/profiles/profileSingleton";
import { useSearchLabels } from "../../SiteNavigation/NavSearch/SearchLabelsContext";
import { getContentTypeLabel } from "../../SiteNavigation/NavSearch/searchLabelHelpers";
import { useAlgoliaConsent } from "@/lib/algoliaConsent";
const indexName = profile.NEXT_PUBLIC_ALGOLIA_SITE_INDEX || "global-production";
interface SearchHitProps {
  hit: any;
  locale: string;
}
const SearchHit = ({
  hit,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  locale
}: SearchHitProps) => {
  const labels = useSearchLabels();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    site,
    contentTypeName,
    title,
    url,
    path
  } = hit || {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const hasLocale = hit.locale;
  const {
    hasAlgoliaConsent
  } = useAlgoliaConsent();

  // Click events are gated on consent so the `_ALGOLIA` cookie and
  // associated user token never leave the browser when the visitor
  // hasn't accepted the configured OneTrust category. AlgoliaInsights
  // Bootstrap is the only code path that calls `aa("init", ...)` — if
  // hasAlgoliaConsent is false, the SDK has either never been
  // initialized or was re-initialized with `useCookie: false`, and we
  // skip the send entirely.
  const handleSearchResultClick = useCallback(async (objectID: any, queryID: any, position: any) => {
    if (!hasAlgoliaConsent) return;
    const userToken = await getUserToken();
    const {
      default: aa
    } = await import("search-insights");
    aa("clickedObjectIDsAfterSearch", {
      userToken,
      eventName: "Click on Search Result",
      index: indexName,
      queryID,
      objectIDs: [objectID],
      positions: [position]
    });
  }, [hasAlgoliaConsent]);
  const renderLinkMarkup = (url_0: string) => {
    const currentLocation = window.location.origin;
    if (url_0.startsWith(currentLocation)) {
      const newUrl = url_0.replace(currentLocation, "");
      return <a href={newUrl} className="nav-search__hit--link" style={{
        margin: 0
      }} onClick={() => handleSearchResultClick(hit?.objectID, hit?.__queryID, hit?.__position)}>
          {title || site || path}
        </a>;
    }
    return <a href={url_0} target="_blank" rel="noreferrer noopener" className="nav-search__hit--link" style={{
      margin: 0
    }} onClick={() => handleSearchResultClick(hit?.objectID, hit?.__queryID, hit?.__position)}>
        {title || site || path}
      </a>;
  };
  return <div>
      <span className="nav-search__hit--breadcrumb">{hit?.hostname}</span>
      <br />
      {url && renderLinkMarkup(url)}
      <div className="nav-search__hit--description">
        {hit?.description || <Snippet attribute="content" hit={hit} />}
      </div>
      {hit.contentType && <div className="nav-search__hit--content-type">
          <strong>{labels.category}:</strong>{" "}
          {getContentTypeLabel(hit?.contentType, labels)}
        </div>}
      <hr className="nav-search__hit--divider"></hr>
    </div>;
};
export default SearchHit;